import { useSwrNoAuth } from "../swr/useSwrNoAuth";


export const useFetchSoCouponUsageStatusByLineId = (restaurantId: string|null, lineId: string) => {
  const { data: soCouponUsageStatus, error, isLoading } = useSwrNoAuth<string>(`socoupon/restaurants/${restaurantId}/line-accounts/${lineId}/socoupon-usage-status/`)
  return { soCouponUsageStatus, isLoading, error };
};